import { render, staticRenderFns } from "./_accessDirect.vue?vue&type=template&id=24e29a0c&"
import script from "./_accessDirect.vue?vue&type=script&lang=js&"
export * from "./_accessDirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports